import { createGlobalStyle } from 'styled-components';

export const GlobalEditorStyles = createGlobalStyle`
  .editor-text-bold {
    font-weight: bold;
  }

  .editor-text-italic {
    font-style: italic;
  }

  .editor-text-underline {
    text-decoration: underline;
  }

  .editor-text-code {
    font-family: Menlo, Consolas, Monaco, monospace;
    background-color: rgb(240, 242, 247);
    padding: 1px 0.25rem;
    border-radius: 3px;
  }

  .editor-text-bold.editor-text-italic {
    font-weight: bold;
    font-style: italic;
  }

  .editor-text-bold.editor-text-underline {
    font-weight: bold;
    text-decoration: underline;
  }

  .editor-text-italic.editor-text-underline {
    font-style: italic;
    text-decoration: underline;
  }

  .editor-text-bold.editor-text-italic.editor-text-underline {
    font-weight: bold;
    font-style: italic;
    text-decoration: underline;
  }
`;
